import { AppointmentType } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/appointment_type.pb';
import { Practitioner } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/practitioner.pb';
import { contextFactory } from '@frontend/design-system';

export type ScheduleMultiSelectDropdownContextType = {
  placeholder: string;
  id: string;
  values: string[];
  initialListValues: Practitioner[] | AppointmentType[];
  defaultSearchValue?: string;
  isRequired?: boolean;
  isError?: boolean;
  setValues: (values: string[]) => void;
  setIsError: (isError: boolean) => void;
  setListValues: (list: Practitioner[] | AppointmentType[]) => void;
  getNameFieldValue: (item: Practitioner | AppointmentType) => string;
};

export const [ScheduleMultiSelectDropdownContext, useScheduleMultiSelectDropdownContext] =
  contextFactory<ScheduleMultiSelectDropdownContextType>(
    'use useScheduleMultiSelectDropdownContext within ScheduleMultiSelectDropdownContextProvider'
  );
